import React from 'react';
import { Card } from 'antd';
import { node, string } from 'prop-types';

const Widget = ({
  title = null, children, styleName = '', cover = null, extra = null, actions = null,
}) => (
  <Card title={title} actions={actions} cover={cover} className={`gx-card-widget ${styleName}`} extra={extra}>
    {children}
  </Card>
);

Widget.propTypes = {
  title: node,
  extra: node,
  cover: node,
  actions: node,
  styleName: string,
  children: node.isRequired,
};

export default Widget;
